import { Archived, ArchivedSchema } from '@/modules/category/schemas/category.schema';
import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document } from 'mongoose';
import { MultilingualTextSchema } from '@/common/schemas/multilingual-text.schema';
import { MultilingualText } from '@/common/dto/multilingual-text.dto';

@Schema({ timestamps: true })
export class Feature extends Document {
  @Prop({ type: ArchivedSchema, required: true })
  icon: Archived;

  @Prop({ type: MultilingualTextSchema, required: true })
  title: MultilingualText;

  @Prop({ type: MultilingualTextSchema, required: true })
  description: MultilingualText;

  @Prop({ default: true })
  isActive: boolean;

  @Prop({ default: 0 })
  sortOrder: number;
}

export const FeatureSchema = SchemaFactory.createForClass(Feature); 